import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CampaignsComponent } from './modules/offers/campaigns/campaigns.component';
import { OfferEditComponent } from './modules/offers/offer-edit/offer-edit.component';
import { ProductListComponent } from './modules/products/product-list/product-list.component';
import { ProductEditComponent } from './modules/products/product-edit/product-edit.component';
import { SignInComponent } from './modules/auth/sign-in.component';
import { AuthGuard } from './services/auth.guard';
import { StatusListComponent } from './modules/lifecycle/status-list/status-list.component';
import { StatusEditComponent } from './modules/lifecycle/status-edit/status-edit.component';
import { OfferListComponent } from './modules/offers/offer-list/offer-list.component';
import { CsvUploadErrorsComponent } from './modules/offers/csv-upload-errors/csv-upload-errors.component';
import { OfferWithdrawnComponent } from './modules/offers/offer-withdrawn/offer-withdrawn.component';
import { RegulationsComponent } from './modules/regulations/regulations.component';
import { MetricsComponent } from './modules/metrics/metrics.component';
import { CsvImportComponent } from './modules/offers/csv-import/csv-import.component';
import { CustomerSegmentsComponent } from './modules/customer-segments/customer-segments.component';
import { CustomerSegmentEditComponent } from './modules/customer-segments/customer-segment-edit/customer-segment-edit.component';
import { DevicesComponent } from './modules/devices/devices.component';
import { LoyalizationComponent } from './modules/loyalization/loyalization.component';
import { SalesChannelComponent } from './modules/sales-channels/sales-channel.component';
import { BusinessRulesListComponent } from './modules/business-rules/business-rules-list/business-rules-list.component';
import { MassOffersEditComponent } from './modules/offers/offer-list/mass-offers-edit/mass-offers-edit.component';

const routes: Routes = [
  { path: 'sign-in', component: SignInComponent },
  { path: 'regulations', component: RegulationsComponent, canActivate: [AuthGuard] },
  { path: 'campaigns', component: CampaignsComponent, canActivate: [AuthGuard] },
  { path: 'import', component: CsvImportComponent, canActivate: [AuthGuard] },
  { path: 'offers', component: OfferListComponent, canActivate: [AuthGuard] },
  { path: 'offers/:id', component: OfferEditComponent, canActivate: [AuthGuard] },
  { path: 'mass-offers-edit', component: MassOffersEditComponent, canActivate: [AuthGuard] },
  { path: 'withdrawn', component: OfferWithdrawnComponent, canActivate: [AuthGuard] },
  { path: 'products', component: ProductListComponent, canActivate: [AuthGuard] },
  { path: 'product/:id', component: ProductEditComponent, canActivate: [AuthGuard] },
  { path: 'product', component: ProductEditComponent, canActivate: [AuthGuard] },
  { path: 'statuses', component: StatusListComponent, canActivate: [AuthGuard] },
  { path: 'status', component: StatusEditComponent, canActivate: [AuthGuard] },
  { path: 'status/:id', component: StatusEditComponent, canActivate: [AuthGuard] },
  { path: 'csv-upload-errors', component: CsvUploadErrorsComponent, canActivate: [AuthGuard] },
  { path: 'metrics', component: MetricsComponent, canActivate: [AuthGuard] },
  { path: 'customer-segment-edit', component: CustomerSegmentEditComponent, canActivate: [AuthGuard] },
  { path: 'customer-segment-edit/:id', component: CustomerSegmentEditComponent, canActivate: [AuthGuard] },
  { path: 'customer-segments', component: CustomerSegmentsComponent, canActivate: [AuthGuard] },
  { path: 'sales-channel', component: SalesChannelComponent, canActivate: [AuthGuard] },
  { path: 'devices', component: DevicesComponent, canActivate: [AuthGuard] },
  { path: 'loyalization', component: LoyalizationComponent, canActivate: [AuthGuard] },
  { path: 'business-rules', component: BusinessRulesListComponent, canActivate: [AuthGuard] },
  { path: '', redirectTo: '/offers', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts